export default {
  copyright: '<a href="https://www.comfortmoney.cz/pujcky/" target="_blank">Comfort Money s.r.o.</a> je přední poskytovatel úvěrů s licencí ČNB',
  cookies: 'Nastavení cookies',
  notYou: {
    label: 'Nejste to vy? Zadejte své údaje.',
    button: 'Nová žádost',
  },
  newForm: {
    label: 'Potřebujete začít novou žádost?',
    button: 'Nová žádost',
  },
  callDesc: ' Jsme vám k dispozici každý pracovní <br> den od 9 do 17 hodin.',
  callTitle: ' Potřebujete poradit?',
};
